<swiper-container fmSwiper [config]="config" init="false" class="w-full">
  @for (slide of slidesParsed; track slide) {
  <swiper-slide>
    <atx-simple-banner
      [media]="slide.media"
      [title]="slide.title"
      [subtitle]="slide.subtitle"
      [routerLink]="slide.routerLink"
      [figureMaxWidth]="figureMaxWidth"
      [disabledRouterLink]="disabledRouterLink"
      (linkClick)="slideRedirectClick.emit(slide)"
    ></atx-simple-banner>
  </swiper-slide>
  }
</swiper-container>
